// helper to delay promise
const wait = (ms) => {
    return (x) => {
        return new Promise(resolve => setTimeout(() => resolve(x), ms))
    }
}

const delay = (ms) => {
    return new Promise((resolve) => setTimeout(resolve, ms))
}

const debounce = (callback, wait) => {
    let timeout = null

    return (...args) => {
        window.clearTimeout(timeout)
        timeout = window.setTimeout(() => {
            callback.apply(this, args)
        }, wait)
    }
}

export { wait, delay, debounce }



// WEBPACK FOOTER //
// ./src/mixins/shared/helpers.js